export function isValidCvr(cvr: string) {
    return /^(?:\d{8})?$/.test(cvr);
}

// Extract exactly 8 consecutive digits possibly preceded by non-digits
export function formatCvr(cvr: string) {
    return /^\D*(\d{8})$/g.exec(cvr)?.[1];
}
